var _path, _path2, _g, _g2, _g3, _path3, _path4, _path5, _path6, _path7, _g4, _path8, _path9, _path10, _g5, _g6, _path11, _path12, _g7, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderPlacedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 143,
    viewBox: "0 0 159 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.4 127C114.2 127 140.8 100.6 140.8 68C140.8 35.4 114.2 9 81.4 9C48.6 9 22 35.4 22 68C22 100.6 48.6 127 81.4 127Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.9 60.3002V96.4002C126.9 103.9 120.8 110 113.2 110H49.7996C42.2996 110 36.1996 104 36.0996 96.5002C36.0996 96.4002 36.0996 96.4002 36.0996 96.3002V60.3002C36.0996 60.2002 36.0996 60.2002 36.0996 60.1002C36.0996 59.9002 36.0996 59.7002 36.1996 59.5002C36.2996 59.2002 36.3996 59.0002 36.4996 58.7002L53.4996 26.2002C54.0996 24.9002 55.3996 24.2002 56.7996 24.2002H106.1C107.5 24.2002 108.7 24.9002 109.4 26.2002L126.4 58.7002C126.5 58.9002 126.6 59.2002 126.7 59.5002C126.9 59.7002 126.9 60.0002 126.9 60.3002Z",
    fill: "url(#paint0_linear_705_7972)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_705_7972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.4998 60.6H68.7998C67.6998 60.6 66.7998 59.8 66.7998 58.6V23.5C66.7998 22.4 67.5998 21.5 68.7998 21.5H94.3998C95.4998 21.5 96.3998 22.3 96.3998 23.5V58.6C96.3998 59.7 95.5998 60.6 94.4998 60.6Z",
    fill: "#F5F8FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_705_7972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103 68.8998H60.2998C58.8998 68.8998 57.7998 67.6998 57.7998 66.3998V32.2998C57.7998 30.8998 58.9998 29.7998 60.2998 29.7998H103C104.4 29.7998 105.5 30.9998 105.5 32.2998V66.3998C105.4 67.7998 104.4 68.8998 103 68.8998Z",
    fill: "#F5F8FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_705_7972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.9 78.5996H55.5002C54.0002 78.5996 52.7002 77.2996 52.7002 75.8996V42.2996C52.7002 40.7996 54.0002 39.5996 55.5002 39.5996H107.9C109.4 39.5996 110.7 40.8996 110.7 42.2996V75.7996C110.6 77.3996 109.4 78.5996 107.9 78.5996Z",
    fill: "#F5F8FF"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M157.123 69.9711L158.371 69.4162C158.787 69.2775 158.787 68.7226 158.371 68.5838L157.123 68.0289C155.598 67.3353 154.351 66.0867 153.658 64.5607L153.103 63.3121C152.964 62.896 152.41 62.896 152.271 63.3121L151.717 64.5607C151.024 66.0867 149.776 67.3353 148.251 68.0289L147.003 68.5838C146.587 68.7226 146.587 69.2775 147.003 69.4162L148.251 69.9711C149.776 70.6648 151.024 71.9133 151.717 73.4393L152.271 74.6879C152.41 75.1041 152.964 75.1041 153.103 74.6879L153.658 73.4393C154.212 71.9133 155.46 70.6648 157.123 69.9711Z",
    fill: "#FF7E00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M148.035 89.9833L148.867 89.5672C149.144 89.4284 149.144 89.151 148.867 89.0122L148.035 88.7348C146.926 88.3186 146.095 87.4862 145.679 86.3764L145.263 85.544C145.124 85.2666 144.847 85.2666 144.708 85.544L144.431 86.3764C143.877 87.4862 143.045 88.3186 142.074 88.7348L141.104 89.151C140.965 89.151 140.965 89.5672 141.104 89.5672L141.936 89.9833C143.045 90.3995 143.877 91.2319 144.431 92.3417L144.847 93.1741C144.986 93.4516 145.263 93.4516 145.401 93.1741L145.679 92.3417C146.095 91.2319 146.926 90.3995 148.035 89.9833Z",
    fill: "#C2C8D6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4318 98.3647L11.6795 97.8098C12.0954 97.671 12.0954 97.1161 11.6795 96.9774L10.4318 96.4225C8.90691 95.7288 7.65925 94.4803 6.96611 92.9543L6.41159 91.7057C6.27296 91.2895 5.71844 91.2895 5.57982 91.7057L5.0253 92.9543C4.33215 94.4803 3.08449 95.7288 1.55958 96.4225L0.311915 96.9774C-0.103972 97.1161 -0.103972 97.671 0.311915 97.8098L1.55958 98.3647C3.08449 99.0583 4.33215 100.307 5.0253 101.833L5.57982 103.081C5.71844 103.498 6.27296 103.498 6.41159 103.081L6.96611 101.833C7.52062 100.307 8.76828 99.0583 10.4318 98.3647Z",
    fill: "#FF7E00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9348 36.3632L11.7666 35.947C12.0439 35.8083 12.0439 35.5309 11.7666 35.3921L10.9348 35.1147C9.8258 34.6985 8.99403 33.8661 8.57814 32.7563L8.16225 31.9239C8.02362 31.6465 7.74637 31.6465 7.60774 31.9239L7.33048 32.7563C6.77596 33.8661 5.94419 34.6985 4.97379 35.1147L4.00339 35.5309C3.86476 35.5309 3.86476 35.947 4.00339 35.947L4.83516 36.3632C5.94419 36.7794 6.77596 37.6118 7.33048 38.7216L7.74637 39.554C7.885 39.8314 8.16225 39.8314 8.30088 39.554L8.57814 38.7216C8.99403 37.6118 9.8258 36.7794 10.9348 36.3632Z",
    fill: "#FF7E00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6087 26.5723L22.3019 26.2948C22.4405 26.1561 22.4405 26.0173 22.3019 25.8786L21.6087 25.6012C20.777 25.3237 20.2225 24.6301 19.8066 23.7977L19.5293 23.104C19.3907 22.9653 19.2521 22.9653 19.1134 23.104L18.8362 23.7977C18.5589 24.6301 17.8658 25.185 17.034 25.6012L16.6181 25.8786C16.3408 26.0173 16.3408 26.2948 16.6181 26.2948L17.3112 26.5723C18.143 26.8497 18.6975 27.5434 19.1134 28.3757L19.3907 29.0694C19.5293 29.2081 19.6679 29.2081 19.8066 29.0694L20.0838 28.3757C20.2225 27.5434 20.9156 26.8497 21.6087 26.5723Z",
    fill: "#C2C8D6"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_705_7972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.2 87.9996H50.2002C48.5002 87.9996 47.2002 86.5996 47.2002 85.0996V51.9996C47.2002 50.2996 48.6002 49.0996 50.2002 49.0996H113.2C114.9 49.0996 116.2 50.4996 116.2 51.9996V84.9996C116.1 86.6996 114.9 87.9996 113.2 87.9996Z",
    fill: "#F5F8FF"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3004 62.1998H70.6004C70.0004 62.1998 69.4004 61.6998 69.4004 60.9998C69.4004 60.3998 69.9004 59.7998 70.6004 59.7998H94.3004C94.9004 59.7998 95.5004 60.2998 95.5004 60.9998C95.5004 61.6998 95.0004 62.1998 94.3004 62.1998Z",
    fill: "#E6ECF5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4002 69.1998H57.4002C57.0002 69.1998 56.7002 68.8998 56.7002 68.4998C56.7002 68.0998 57.0002 67.7998 57.4002 67.7998H87.3002C87.7002 67.7998 88.0002 68.0998 88.0002 68.4998C88.2002 68.6998 87.9002 69.1998 87.4002 69.1998Z",
    fill: "#E6ECF5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M107.1 69.1998H91.9998C91.5998 69.1998 91.2998 68.8998 91.2998 68.4998C91.2998 68.0998 91.5998 67.7998 91.9998 67.7998H107C107.4 67.7998 107.7 68.0998 107.7 68.4998C107.9 68.6998 107.6 69.1998 107.1 69.1998Z",
    fill: "#E6ECF5"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_705_7972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.682 62.1104V96.3364C121.682 101.204 117.788 105.099 112.831 105.099H50.1681C45.3002 105.099 41.3174 101.204 41.3174 96.3364V61.9334C41.3174 61.7564 41.3174 61.5794 41.4059 61.4023H58.5856C61.5949 61.4023 64.0731 63.792 64.0731 66.8898C64.0731 68.3944 64.6926 69.8106 65.6662 70.7841C66.7283 71.8462 67.9674 72.3773 69.5605 72.3773H94.5275C97.5368 72.3773 100.015 69.9876 100.015 66.8898C100.015 65.3852 100.635 63.9691 101.608 62.9955C102.67 61.9334 103.909 61.4023 105.414 61.4023H121.505C121.682 61.5794 121.682 61.8449 121.682 62.1104Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_705_7972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.9 60.3V100.1C126.9 105.6 122.5 110 116.9 110H46.0996C40.5996 110 36.0996 105.6 36.0996 100.1V60.1C36.0996 59.9 36.0996 59.7 36.1996 59.5H58.9996C62.3996 59.5 65.1996 62.2 65.1996 65.7C65.1996 67.4 65.8996 69 66.9996 70.1C68.1996 71.3 69.5996 71.9 71.3996 71.9H91.6996C95.0996 71.9 97.8996 69.2 97.8996 65.7C97.8996 64 98.5996 62.4 99.6996 61.3C100.9 60.1 102.3 59.5 104 59.5H126.7C126.9 59.7 126.9 60 126.9 60.3Z",
    fill: "url(#paint1_linear_705_7972)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M116.9 95.6H96.3C95.6 95.6 95 95.1 95 94.3C95 93.6 95.5 93 96.3 93H116.7C117.4 93 118 93.5 118 94.3C118.1 94.9 117.5 95.6 116.9 95.6Z",
    fill: "#E6ECF5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M107.7 101.9H96.3C95.6 101.9 95 101.4 95 100.6C95 99.8998 95.5 99.2998 96.3 99.2998H107.6C108.3 99.2998 108.9 99.7998 108.9 100.6C109 101.2 108.4 101.9 107.7 101.9Z",
    fill: "#E6ECF5"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_705_7972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.607 106.1C100.207 107.8 99.6071 109.6 98.9071 111.1C97.0071 114.8 94.0071 117.7 90.3071 119.6C86.5071 121.5 82.0071 122.3 77.5071 121.3C66.8071 119 60.0071 108.7 62.2071 98.0997C64.4071 87.4997 74.7071 80.5997 85.3071 82.8997C89.1071 83.6997 92.4071 85.5997 95.2071 88.1997C100.007 92.8997 101.907 99.5997 100.607 106.1Z",
    fill: "url(#paint2_linear_705_7972)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9017 109.969C78.4811 109.969 78.0853 109.815 77.7637 109.483L72.2968 103.833C71.6784 103.194 71.6784 102.12 72.2968 101.481C72.9153 100.842 73.9542 100.842 74.5726 101.481L78.9017 105.955L89.0934 95.4481C89.7118 94.809 90.7508 94.809 91.3692 95.4481C91.9876 96.0872 91.9876 97.1609 91.3692 97.8L80.0396 109.483C79.7427 109.815 79.3222 109.969 78.9017 109.969Z",
    fill: "#F6F8FB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_705_7972",
    x: 44.7998,
    y: 0.5,
    width: 73.5996,
    height: 83.0996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_705_7972"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_705_7972",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_705_7972",
    x: 35.7998,
    y: 8.7998,
    width: 91.7002,
    height: 83.0996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_705_7972"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_705_7972",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_705_7972",
    x: 30.7002,
    y: 18.5996,
    width: 102,
    height: 83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_705_7972"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_705_7972",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_705_7972",
    x: 25.2002,
    y: 28.0996,
    width: 113,
    height: 82.9004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_705_7972"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_705_7972",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_705_7972",
    x: 28.3174,
    y: 45.4023,
    width: 106.365,
    height: 69.6963,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_705_7972"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_705_7972",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_705_7972",
    x: 14.0996,
    y: 48.5,
    width: 134.8,
    height: 94.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_705_7972"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_705_7972",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_705_7972",
    x: 57.7939,
    y: 82.457,
    width: 47.2119,
    height: 49.2754,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.352941 0 0 0 0 0.486275 0 0 0 0 0.937255 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_705_7972"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_705_7972",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_705_7972",
    x1: 81.5068,
    y1: 27.1808,
    x2: 81.5068,
    y2: 75.3395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_705_7972",
    x1: 81.47,
    y1: 58.3319,
    x2: 81.47,
    y2: 110.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_705_7972",
    x1: 67.7351,
    y1: 87.8128,
    x2: 96.2992,
    y2: 116.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ED259"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53C28C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderPlacedIcon);
export default __webpack_public_path__ + "static/media/orderPlacedIcon.5c4dec40573591d33bbff9544cdcc27b.svg";
export { ForwardRef as ReactComponent };